import React, { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import ApiSession from "../api/ApiSession";
import ProgressBarContainer from "../components/progressBar/progressBarContainer";
import SystemPage from "./SystemPageHook";
import embLabels from "../config/emb-labels-en.json";
import RoutingSettings from "./RoutingPages/RoutingSettingsHook";
import { useDispatch, useSelector } from "react-redux";
import { getProjectId, getProjectTypeValue } from "../utils/project";
import TimeSync from "./SystemPages/TimeSync";
import useProjectTypeValue from "../utils/useCurrentProjectValue";
import { withRouter } from "react-router-dom";
import SecureArchitectureHook from "./SecureArchitectureHook";
import { useAtom } from "jotai";
import { projectAtomList } from "../atoms";
import TagListManagement from "../components/TagListManagement";

const apiSession = new ApiSession();
const Systems = (props) => {
  const [timeSyncData, setTimeSyncData] = useState();
  const [key, setKey] = useState("secure");
  const [loading, setLoading] = useState(true);
  const [projectInformationData, setProjectInformationData] = useState();
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [siteCreated, setSiteCreated] = useState(false);
  const [siteType, setSiteType] = useState("");
  const [boostProSelected, setBoostProSelected] = useState(false);
  const [clientType, setClientType] = useState("");
  const [architectureType, setArchitectureType] = useState("");
  const [currentProject, setCurrentProject] = useAtom(projectAtomList)
  const projectStatusData = currentProject?.projectStatus
  const projectTypeValue = useProjectTypeValue();
  let userSampleData = {
    name: "",
    role: "",
    access: "",
  };
  const dispatch = useDispatch();
  let userScope =
    JSON.parse(localStorage.getItem("scope")) !== null
      ? JSON.parse(localStorage.getItem("scope"))
      : userSampleData;
  const [UserScope] = useState(userScope);
  const { projectId } = props?.match?.params;
  const [secureArchitectureData,setSecureArchitectureData] = useState();

//  const secureArchitectureData = useSelector(
//     (state) => state?.secureArchitectureData?.data
//   );
  const getsecureArchitectureData = () =>{
    apiSession.getSecureArchitectureData(projectId)
    .then(response=>{
      if(response){
        setSecureArchitectureData(response)
      }
      
    })
  }
  useEffect(() => {
    
    if (!projectId) {
      let { history } = props;
      history.push({
        pathname: "/information/new",
      });
    } else {
      try {
        setLoading(true);
        getsecureArchitectureData();
        apiSession
          .getSystemInfo(projectId)
          .then((response) => {
            setSiteType(response?.siteType);
            setBoostProSelected(response?.isBoostPro);
            setClientType(response?.clientType);
            setArchitectureType(response?.architecture);
            setSiteCreated(response?.siteCreated);
            setProjectInformationData(response);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      } catch (error) {
        console.log("Error fetching system info:", error);
      }
    }
  }, []);

  return (
    <div className=" container-fluid h-100 container-margin">
      <se-container option="centered">
        <div className="row">
          {UserScope.access.saveSystemInfo !== true && (
            <div className="col-sm-12 text-center mt-1">
              <span className="se-error-message-note text-center">
                {`Information: ${UserScope.role} is not authorized to perform action on this page`}
              </span>
            </div>
          )}
          {(projectStatusData?.projectStatus === "COMPLETED" ||
            projectStatusData?.projectStatus === "COMPLETED_AND_SEND") && (
            <div className="col-sm-12 text-center mt-1">
              <span className="se-error-message-note text-center">
                {`Change the project state to in-progress to update the project`}
              </span>
            </div>
          )}
          {UserScope.access.saveSystemInfo &&( siteCreated && projectTypeValue !== "NMGaaS ETO")&& (
            <div className="col-sm-12 text-center mt-1">
              <span className="se-error-message-note text-center">
                {`Site already created for the project, no more modifications allowed`}
              </span>
            </div>
          )}
        </div>
        <div className="container-fluid mt-1 mb-1">
          <Tabs
            id="controlled-tab"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
             {siteType === embLabels.GRID_CONNECTED_GSX ||
            siteType === embLabels.ISLANDABLE_GSX ||
            projectTypeValue === "MGaaS ANSI" ||
            (siteType === embLabels.GRID_CONNECTED &&
              (projectTypeValue === "MGaaS IEC" ||
                projectTypeValue === "MGaaS ETO" ||
                projectTypeValue === "NMGaaS ETO")) ||
                (siteType === embLabels.PV_HYBRIDIZATION && 
                 (projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) ||
            ((siteType === embLabels.ISLANDABLE || siteType === "OFF_GRID") &&
              (projectTypeValue === "MGaaS IEC" ||
                projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) ? (
              <Tab eventKey="secure" title="Secure Architecture">
                <SecureArchitectureHook
                  projectStatusData={projectStatusData}
                  siteCreated={siteCreated}
                  siteType={siteType}
                  setKey={setKey}
                  secureArchitectureData = {secureArchitectureData}
                  setSecureArchitectureData={setSecureArchitectureData}
                  architectureType={architectureType}
                  projectTypeValue={projectTypeValue}
                  projectId={projectId}
                  timeSyncData={timeSyncData}
                />
              </Tab>
            ) : (
              ""
            )}
            <Tab eventKey="system" title="System Setting">
              <SystemPage
                projectInformationData={projectInformationData}
                projectStatusData={projectStatusData}
                siteCreated={siteCreated}
                boostProSelected={boostProSelected}
                setKey={setKey}
                key={key}
                timeSyncData={timeSyncData}
                secureArchitectureData = {secureArchitectureData}

                />
            </Tab>
           
            {siteType === embLabels.GRID_CONNECTED_GSX ||
            siteType === embLabels.ISLANDABLE_GSX ||
            projectTypeValue === "MGaaS ANSI" ||
            (siteType === embLabels.GRID_CONNECTED &&
              (projectTypeValue === "MGaaS IEC" ||
                projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) ||
                (siteType === embLabels.PV_HYBRIDIZATION && 
                    (projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) ||
            ((siteType === embLabels.ISLANDABLE || siteType === "OFF_GRID")&&
              (projectTypeValue === "MGaaS IEC" ||
                projectTypeValue === "MGaaS ETO" || projectTypeValue === "NMGaaS ETO")) ? (
              <Tab eventKey="routing" title="Routing">
                <RoutingSettings
                  projectStatusData={projectStatusData}
                  siteCreated={siteCreated}
                  projectId={projectId}
                  secureArchitectureData = {secureArchitectureData}
                />
              </Tab>
            ) : (
              ""
            )}
            {siteType !== "GENSET_PVBESS_A2E" &&
              projectTypeValue !== "MGaaS AccessToEnergy" && (
                <Tab eventKey="time" title="Time Synchronization">
                  <TimeSync
                    setTimeSyncData={setTimeSyncData}
                    projectStatusData={projectStatusData}
                    siteCreated={siteCreated}
                    siteType={siteType}
                    secureArchitectureData = {secureArchitectureData}
                    setKey={setKey}
                    projectTypeValue = {projectTypeValue}
                  />
                </Tab>
              )}

              { 
              projectTypeValue === "NMGaaS ETO" &&
              (
              
                  <Tab eventKey="tags" title="Tags Management">
                    <TagListManagement
                     projectId={projectId}
                      projectStatusData={projectStatusData}
                    ></TagListManagement>
                  </Tab>
                
              )

              }
          </Tabs>
        </div>
      </se-container>
      <se-snackBar
        id="custom-systempage"
        type={snackBar.type}
        message={snackBar.message}
        icon="information_stroke"
        duration="3000"
      ></se-snackBar>
    </div>
  );
};

export default withRouter(Systems);
